import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { EditPermissions } from '../../../../../../../shared/models';
import { getEditTypes } from '../../../delegatorUtils';
import { newStepValue } from '../../../../../services/flowBuilder/utils/constants';
import { required } from '../../../../../../../shared/utils';

export interface iMessageFormData {
  menuHeader: string,
  subtitle: string,
  imageReference: string,
  imageTitle: string,
  imageSubtitle: string,
  appIconReference: string,
  appId: string,
  appName: string,
  bid: string,
  URL: string,
  secondarySubtitle: string,
  tertiarySubtitle: string,
  next: string
}

export class iMessage {
  private menu: any = {};

  constructor() {
    this.menu = {
      'menuType': 'iMessage',
    };
  }

  static toForm(stepData: { [index: string]: any }, editPermissions: EditPermissions): UntypedFormGroup {
    const { editMenuTextOnly, editFlows } = getEditTypes(editPermissions);
    const formData = this.getFromData(stepData);

    return this.buildForm(formData, editFlows);
  }

  private static getFromData(stepData: { [index: string]: any }): iMessageFormData {
    const menu = stepData?.menu ? stepData?.menu : {};
    const menuParams = menu?.menuParams ? menu?.menuParams : {};

    return {
      menuHeader: this.getOrDefault(menu?.menuHeader),
      subtitle: this.getOrDefault(menuParams?.subtitle),
      imageReference: this.getOrDefault(menuParams?.imageReference),
      imageTitle: this.getOrDefault(menuParams?.imageTitle),
      imageSubtitle: this.getOrDefault(menuParams?.imageSubtitle),
      appIconReference: this.getOrDefault(menuParams?.appIconReference),
      appId: this.getOrDefault(menuParams?.appId),
      appName: this.getOrDefault(menuParams?.appName),
      bid: this.getOrDefault(menuParams?.bid),
      URL: this.getOrDefault(menuParams?.URL),
      secondarySubtitle: this.getOrDefault(menuParams?.secondarySubtitle),
      tertiarySubtitle: this.getOrDefault(menuParams?.tertiarySubtitle),
      next: stepData.next ? stepData.next : newStepValue,
    };
  }

  private static getOrDefault(value: string, defaultValue: any = ''): any {
    if (value === undefined || !value) {
      return defaultValue;
    }

    return value;
  }

  private static buildForm(formData: iMessageFormData, editFlows: boolean): UntypedFormGroup {
    return new UntypedFormGroup({
      menuHeader: new UntypedFormControl({
        value: formData.menuHeader,
        disabled: !editFlows,
      }, required('Title')),
      subtitle: new UntypedFormControl({
        value: formData.subtitle,
        disabled: !editFlows,
      }),
      imageReference: new UntypedFormControl({
        value: formData.imageReference,
        disabled: !editFlows,
      }),
      imageTitle: new UntypedFormControl({
        value: formData.imageTitle,
        disabled: !editFlows,
      }),
      imageSubtitle: new UntypedFormControl({
        value: formData.imageSubtitle,
        disabled: !editFlows,
      }),
      appIconReference: new UntypedFormControl({
        value: formData.appIconReference,
        disabled: !editFlows,
      }, required('App Icon Reference')),
      appId: new UntypedFormControl({
        value: formData.appId,
        disabled: !editFlows,
      }, required('App ID')),
      appName: new UntypedFormControl({
        value: formData.appName,
        disabled: !editFlows,
      }, required('App Name')),
      bid: new UntypedFormControl({
        value: formData.bid,
        disabled: !editFlows,
      }, required('Bid')),
      URL: new UntypedFormControl({
        value: formData.URL,
        disabled: !editFlows,
      }, required('URL')),
      secondarySubtitle: new UntypedFormControl({
        value: formData.secondarySubtitle,
        disabled: !editFlows,
      }),
      tertiarySubtitle: new UntypedFormControl({
        value: formData.tertiarySubtitle,
        disabled: !editFlows,
      }),
      next: new UntypedFormControl({
        value: formData.next,
        disabled: !editFlows,
      }),
    });
  }

  public setMenu(rawData): void {
    const menu = {
      ...this.menu,
      menuHeader: rawData.menuHeader,
    };

    const menuParams = {
      subtitle: rawData.subtitle,
      imageReference: rawData.imageReference,
      imageTitle: rawData.imageTitle,
      imageSubtitle: rawData.imageSubtitle,
      appIconReference: rawData.appIconReference,
      appId: rawData.appId,
      appName: rawData.appName,
      bid: rawData.bid,
      URL: rawData.URL,
      secondarySubtitle: rawData.secondarySubtitle,
      tertiarySubtitle: rawData.tertiarySubtitle,
    };

    this.menu = {
      ...menu,
      menuParams,
    };
  }

  get nodeData(): {} {
    return {
      menu: this.menu,
      'type': 'menu',
      metadata: {
        nodeVersion: '1.0.0',
      },
    };
  }
}
